import { useSelector } from 'react-redux'
import { List, Stack } from '@mui/material'
import { useMemo } from 'react'
import { useCreateFormatNumber } from '@/hooks'
import { selectLoadsFromVehiclesAsSet } from '@/features/domain/vehicle'
import { preview } from '@/components/form/preview'
import { useTexts } from '../useTexts'
import { LoadsAlert } from '../../../../components/LoadsAlert'
import { LoadName } from '../../../../components/LoadName'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function Loads(props: Props) {
  const { extOrder } = props
  const vehiclesLoads = useSelector(selectLoadsFromVehiclesAsSet)

  const texts = useTexts()
  const formatNumber = useCreateFormatNumber()

  const value = useMemo(() => {
    if (!extOrder.order.loads || Object.keys(extOrder.order.loads).length === 0) {
      return null
    }

    const hasAtLeastOneWarning = Object.keys(extOrder.order.loads).some(l => !vehiclesLoads.has(l))

    return (
      <Stack gap={1} component="span">
        <List dense disablePadding component="span">
          {Object.entries(extOrder.order.loads).map(([key, value]) => (
            <preview.LabelValueRow
              key={`${key}-${value}`}
              label={<LoadName name={key} vehiclesLoads={vehiclesLoads} />}
            >
              {formatNumber(value / 100)}
            </preview.LabelValueRow>
          ))}
        </List>
        {hasAtLeastOneWarning && <LoadsAlert />}
      </Stack>
    )
  }, [texts, extOrder.order.loads, vehiclesLoads])

  return <preview.Field label={texts.loads.label}>{value ?? <preview.NullValue />}</preview.Field>
}
